import { WifiOff, RefreshCw, Eye } from 'lucide-react';
import { useConnectionStore } from '../../core/stores/connectionStore.js';
import { useAuthStore } from '../../core/stores/authStore.js';

export function OfflineBanner() {
  const isOnline = useConnectionStore((s) => s.isOnline);
  const wsStatus = useConnectionStore((s) => s.wsStatus);

  if (isOnline && wsStatus !== 'reconnecting') return null;

  const isOffline = !isOnline;
  const message = isOffline
    ? 'You are offline. Some features may be unavailable.'
    : 'Reconnecting…';

  return (
    <div className="fixed top-0 left-0 right-0 z-[90] flex items-center justify-center gap-2 bg-brand px-4 py-2.5 text-center text-sm font-medium text-accent-peach shadow-[var(--shadow-md)]">
      {isOffline ? <WifiOff className="h-4 w-4 shrink-0" /> : <RefreshCw className="h-4 w-4 shrink-0 animate-spin" />}
      {message}
    </div>
  );
}

export function ImpersonationBanner() {
  const isImpersonating = useAuthStore((s) => s.isImpersonating);
  const currentUser = useAuthStore((s) => s.currentUser);
  const originalUser = useAuthStore((s) => s.originalUser);

  if (!isImpersonating || !currentUser) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[90] flex items-center justify-center gap-2 bg-accent-peach-text px-4 py-2.5 text-center text-sm font-medium text-white shadow-[var(--shadow-md)]">
      <Eye className="h-4 w-4 shrink-0" />
      Viewing as {currentUser.name || currentUser.username}
      {originalUser && ` (logged in as ${originalUser.name})`}
    </div>
  );
}
